import { supabase } from './supabaseClient';
export function normalizeCompanyHostname(value) {
  const hostname = String(value || '').trim().toLowerCase().replace(/\.$/, '');
  if (hostname.length > 253 || !hostname.includes('.') || /^[0-9.]+$/.test(hostname)) return null;
  return hostname.split('.').every(label => label.length <= 63 && /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(label)) ? hostname : null;
}
export async function companyDomainCall(companyId, action, hostname = null, verified = false) {
  if (['add','check','activate','disable','delete','sync'].includes(action)) {
    const {data}=await supabase.auth.getSession();
    if(!data?.session?.access_token) throw new Error('Please sign in again.');
    const response=await fetch('/api/company-domains',{
      method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${data.session.access_token}`},
      body:JSON.stringify({company_id:companyId,action,hostname,verified})
    });
    const result=await response.json().catch(()=>null);
    if(!response.ok) throw new Error(result?.error || 'Could not update the company address.');
    const websiteResponse=result?.cloudflare && typeof result.cloudflare.ready==='boolean' && Array.isArray(result.cloudflare.dns_records);
    if(result?.domain?.hostname!==hostname || (!websiteResponse && typeof result?.redirect_sync?.ok!=='boolean')) throw new Error('Could not confirm company website setup. Refresh and retry.');
    return result;
  }
  const { data, error } = await supabase.rpc('company_domain_admin', {
    p_company_id: companyId, p_action: action, p_hostname: hostname, p_verified: verified
  });
  if (error) throw new Error(error.code === 'PGRST202' ? 'Company domain setup is required. Run supabase/company_domains_update.sql.' : error.message);
  return data;
}
